"use client";

import { useId, useState } from "react";
import Modal from "~/common/components/Modal";
import { DemoForm } from "~/redesign/components/DemoForm";
import { useExperience } from "~/redesign/components/Experience";
import { getPrivacyRequestCopy } from "~/common/lib/privacyRequests";
import styles from "./PrivacyRequestButton.module.scss";

export default function PrivacyRequestButton({ requestType }) {
  const { locale } = useExperience();
  const copy = getPrivacyRequestCopy(locale, requestType);
  const id = useId();
  const idPrefix = `privacy-request-${id}`;
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const close = () => { if (!submitting) setOpen(false); };

  return <>
    <button type="button" className={styles.trigger} onClick={() => setOpen(true)}>{copy.title}</button>
    <Modal idPrefix={idPrefix} title={copy.title} open={open} onClose={close}
      closeOnBackdrop={!submitting} panelClassName={styles.panel}>
      <p className={styles.description}>{copy.description}</p>
      <DemoForm idPrefix={idPrefix} showTitle={false} contactOnly
        formLabel={copy.title} submitLabel={copy.submit}
        privacyRequestType={requestType} onSubmittingChange={setSubmitting}/>
    </Modal>
  </>;
}
